export default {
  noSelection: '--Do Not Select--',
  weighing: 'WEIGHING',
  type: 'TYPE',
  mergeConfirmTitle: 'Merge the Activity/Evaluation data into the session?',
  mergeConfirmText:
    'The following will be added to the session: {achievementIndicators}, contents, {methodologicalStrategies}, {autonomousActivities} and bibliography from the selected Activity/Evaluation, without removing what is already selected. If you cancel, only the link to the Activity/Evaluation will be saved.',
  selectionsMerged:
    "The selected Activity/Evaluation's data was added to the session.",
};
